export const descriptions = Array.from(new Set([
    "I'm sexy, and I know it", 
    "I'm 99% coffee and 1% sparkles. Swipe right if you can handle the caffeine-fueled fun!",
    "Professional napper seeking a cuddle partner. Must appreciate cheesy jokes and extra blankets.",
    "Pizza lover with a side of wanderlust. Let's travel the world one slice at a time!",
    "Plant mom looking for someone to help me keep my succulents alive. Bonus points if you're not a serial plant killer!",
    "Life's a beach, and I'm just here for the sunscreen and sunsets. Seeking a sunset chaser!",
    "Netflix enthusiast and proud member of the 'No Spoilers' club. Let's watch our favorite shows together.",
    "Dog lover, meme connoisseur, and brunch enthusiast. Looking for someone to share dog memes and pancakes with.",
    "Adventurous spirit seeking a partner in crime for spontaneous road trips and taco adventures.",
    "I'm fluent in sarcasm and dad jokes. Swipe right if you can handle the pun-derful journey!",
    "Outdoor enthusiast who's always up for a hike or a picnic. Let's find the best views together!",
    "Bookworm seeking someone to discuss fictional worlds and debate which Hogwarts house is the best.",
    "Professional foodie on a mission to find the best tacos in town. Join me on this delicious quest!",
    "Coffee addict by day, stargazer by night. Let's have deep conversations under the starry sky.",
    "Part-time superhero, full-time daydreamer. Seeking a partner in crime for epic adventures.",
    "Sushi lover looking for someone to share rolls and cheesy jokes with. Soy into you!",
    "Life's too short to be serious. Let's make each other laugh and create our own inside jokes.",
    "Hiker by day, Netflix binger by night. Seeking a binge-watching partner with a sense of adventure.",
    "Fitness enthusiast who believes in balance (between gym and pizza). Let's break a sweat together!",
    "Proud introvert with a secret love for karaoke. Seeking someone to duet 'Don't Stop Believin'.",
    "Travel junkie in search of a co-pilot for spontaneous getaways. Let's explore the unknown!",
    "I put the 'elusive' in 'mysterious.' Can you solve the riddle of my heart?",
    "Professional dog petter and ice cream enthusiast. Seeking someone to share pawsitive vibes.",
    "Napping expert with a PhD in Netflixology. Looking for a cuddle buddy to Netflix and snuggle.",
    "Hogwarts dropout seeking a magical connection. Let's make mischief together!",
    "Life is too short for bad vibes and boring conversations. Swipe right if you're up for something extraordinary!",
    "Life is too short for bad vibes and boring conversations. Swipe right if you're up for something extraordinary!",
    "Professional cuddler and pillow fort architect. Seeking someone to build cozy forts and binge-watch cartoons.",
    "Veggie lover on a mission to find the world's best avocado toast. Let's brunch our way around the city!",
    "Treasure hunter seeking a partner for epic scavenger hunts and late-night snack raids.",
    "Certified dog whisperer and star gazer. Let's explore the universe and pet all the dogs along the way.",
    "Wine enthusiast and cheese aficionado. Looking for someone to share a bottle and create a 'grate' love story.",
    "Always down for a spontaneous dance-off. Can you keep up with my moves on the dance floor?",
    "Nature lover on a quest to hug every tree in the forest. Join me in embracing the great outdoors!",
    "Believer in 'carpe diem' and making everyday moments unforgettable. Let's seize the day together!",
    "Amateur chef whipping up delicious meals and cheesy pickup lines. Swipe right if you can handle the heat.",
    "Horror movie fanatic who thrives on jump scares and popcorn. Let's have a scream-worthy movie night!",
    "Part-time superhero, part-time superhero's sidekick. Seeking a partner in justice and late-night pizza.",
    "Champion of dad jokes and puns. Prepare for a daily dose of laughter and groans.",
    "Moonlight photographer capturing the beauty of the night. Want to be my star in the night sky?",
    "Professional beach bum with a passion for beach volleyball and sunset picnics. Let's ride the wave of life!",
    "Crazy cat person who's also oddly obsessed with conspiracy theories. Let's unravel the mysteries together!",
    "Master of board games and trivia night champion. Looking for someone to challenge my intellect.",
    "Coffee shop regular and latte art enthusiast. Swipe right if you appreciate a perfectly frothy heart in your cup.",
    "Binge-watcher of all things sci-fi and fantasy. Seeking a fellow nerd to debate the best fandoms.",
    "Occasional poet and hopeless romantic. Let's write our own love story in verse.",
    "Sushi lover in search of someone who can roll with the punches (and the sushi rolls).",
    "Professional risk-taker and thrill-seeker. Seeking an adrenaline junkie for daring adventures.",
    "Amateur astronomer in awe of the cosmos. Want to join me on a journey through the stars?",
    "Fluent in emoji and meme-speak. Let's communicate in gifs and laughter.",
    "Lover of all things vintage and retro. Seeking a partner for thrift store adventures and vinyl record nights.",
    "Lover of all things vintage and retro. Seeking a partner for thrift store adventures and vinyl record nights.",
    "Glamour and giggles, all in one swipe. Ready for the adventure?",
    "Diamond in the rough. Let's shine together.",
    "Chasing dreams and sunsets. Wanna be my co-adventurer?",
    "I'm not a photographer, but I can picture us together.",
    "Flirty, fun, and fabulous. Swipe right for a little sparkle.",
    "Dancing under city lights. Join me on the dance floor?",
    "Confidence is my best accessory. Let's strut through life together.",
    "Let's make memories worth swiping right for.",
    "Classy with a hint of sassy. Ready for our next chapter?",
    "Seeking someone to steal hearts and explore the world.",
    "Life's a runway, and I'm serving looks and laughter.",
    "Flirt like no one's watching. Shall we?",
    "Champagne wishes and starry night kisses. Let's toast to us.",
    "Redefining romance, one swipe at a time.",
    "Striving for 'Fabulous.' Can you keep up?",
    "Hearts and hashtags, ready to trend together.",
    "Swipe right and let's script our own love story.",
    "Vintage vibes, modern heart. Swipe right for timeless love.",
    "More than a pretty face; swipe right for substance.",
    "Elegance meets mischief. Join me on this journey.",
    "Twinkling eyes and endless adventures. Care to join?",
    "Spontaneity and style, a match made in heaven.",
    "Dress classy, swipe cheeky. Ready for our stylish adventure?",
    "Making memories, one smile at a time. Swipe right!",
    "Adventure seeker with a dash of daring. Let's explore!",
    "Adventure seeker with a dash of daring. Let's explore!",
    "Swipe right if you're down for some epic memeing.",
    "Netflix, snacks, and chill? Sounds like a date plan.",
    "Slaying life, one emoji at a time. 😎✌️",
    "Looking for someone to share TikToks and tacos with.",
    "Swipe right if you're up for late-night deep talks. 🌙🗣️",
    "Fluent in sarcasm and emoji. Can you keep up? 😂🔥",
    "Let's vibe and create some Insta-worthy moments.",
    "Pizza lover on a quest for the perfect slice. 🍕❤️",
    "Swipe right if you're as extra as my Bitmoji. 😜✨",
    "I'm a mixtape waiting to be your next hit. 🎶❤️",
    "Professional snapchatter and dog filter enthusiast. 🐶💁‍♀️",
    "Swipe right if you believe in love, laughter, and Lizzo. 🎶💖",
    "Seeking a partner in crime for food truck adventures. 🌮🚚",
    "Swipe right for puns, fun, and some serious banter. 😂💬",
    "Life's a game, and I'm winning the fun level. 🎮🕹️",
    "Emoji charades anyone? Let's make it lit! 🔥😄",
    "More puns than you can handle. Swipe right if you dare. 😏🙃",
    "A selfie a day keeps boredom away. 📸😁",
    "Searching for someone as weird as my GIF collection. 🤪🚀",
    "Swipe right if you're into spontaneous dance-offs. 💃🕺",
    "Looking for someone to share the aux cord and playlists with. 🎵🔊",
    "Just a Gen Z soul navigating a millennial world. 🌍🌟",
    "Swipe right for cat pics, conspiracy theories, and chaos. 🐱🌌",
    "Life's too short to take it too seriously. Swipe right for fun! 😄🎉",
    "Adventurous spirit with a passion for spontaneity. Let's vibe!",
    "Swipe right if you're down for some epic memeing.",
    "Netflix, snacks, and chill? Sounds like a date plan.",
    "Slaying life, one emoji at a time.",
    "Looking for someone to share TikToks and tacos with.",
    "Swipe right if you're up for late-night deep talks.",
    "Fluent in sarcasm and emoji. Can you keep up?",
    "Let's vibe and create some Insta-worthy moments.",
    "Pizza lover on a quest for the perfect slice.",
    "Swipe right if you're as extra as my Bitmoji.",
    "I'm a mixtape waiting to be your next hit.",
    "Professional snapchatter and dog filter enthusiast.",
    "Swipe right if you believe in love, laughter, and Lizzo.",
    "Seeking a partner in crime for food truck adventures.",
    "Swipe right for puns, fun, and some serious banter.",
    "Life's a game, and I'm winning the fun level.",
    "Emoji charades anyone? Let's make it lit!",
    "More puns than you can handle. Swipe right if you dare.",
    "A selfie a day keeps boredom away.",
    "Searching for someone as weird as my GIF collection.",
    "Swipe right if you're into spontaneous dance-offs.",
    "Looking for someone to share the aux cord and playlists with.",
    "Just a Gen Z soul navigating a millennial world.",
    "Swipe right for cat pics, conspiracy theories, and chaos.",
    "Life's too short to take it too seriously. Swipe right for fun!",
    "Adventurous spirit with a passion for spontaneity. Let's vibe!"
]));